import type { CSSProperties } from 'react';
import type { MgmBrand } from '../model/types';

/**
 * Cor da loja nas páginas públicas do MGM (mesma ideia do `--invite-accent`
 * do convite). O legado grava a cor como `rgb(r,g,b)` ou hex; o CSS aceita as
 * duas. Sem cor, cai na primária do tema.
 */
export function accentStyle(brand: MgmBrand | null | undefined): CSSProperties {
  const accent = brand?.backgroundColor?.trim();
  const onAccent = brand?.foregroundColor?.trim();
  const style: Record<string, string> = {};
  if (accent) style['--mgm-accent'] = accent;
  // Cor da loja sem cor de texto definida: branco (as cores de marca são quase sempre escuras).
  if (onAccent) style['--mgm-on-accent'] = onAccent;
  else if (accent) style['--mgm-on-accent'] = '#ffffff';
  return style as CSSProperties;
}
